<template>
  <div id="edit__project__modal" class="project-modal edit-deliverable-modal edit-project-modal" :class="!userCanEditProject ? 'read-only' : ''">
    <!-- <div class="departments__wrapper">
      <ProjectDepartments v-if="isMobile()" :deliverable="projectDetail" />
    </div> -->
    <!-- <label v-if="isMobile()" class="form-group w-100 sticky__delv__title">
      <h1
      @click="activateTitleField"
      class="exclude-outside-click edit-d-title d eliverable-title"
      v-show="!editTitle"
      >{{ projectDetail.title || 'Click to set...' }}</h1>
      <textarea
      v-click-outside="outside"
      ref="deliverableTitle"
      v-show="editTitle"
      v-model="projectDetail.title"
      type="text"
      placeholder="Project title..."
      class="form-control mb-3 title-field exclude-outside-click h1"
      @change="updateProjectTitle"
      @blur="editTitle=false;"></textarea>
    </label> -->
    <div class="project--top--section">
      <div class="row">
        <div class="col-md-8 d-flex left--side">
          <div class="project--page--title">
            <h2 class="d-inline-block">
              <div class="project-icon bigger-icon pointer-default" :style="{backgroundColor: getProjectColor(projectDetail)}">
                <img src="@/csmworkflow/img/white-folder.svg"/>
              </div>
            </h2>
            <div class="text--section">
              <div class="project--department--wrap">
                <ProjectDepartments :deliverable="projectDetail" />
              </div>
              <label class="mb-0 w-100">
                <h1
                style="line-height: 1;"
                @click="activateTitleField"
                class="mb-0 exclude-outside-click edit-d-title project-title"
                v-show="!editTitle"
                >{{ projectDetail.title || 'Click to set...' }}</h1>
                <textarea
                v-click-outside="outside"
                ref="deliverableTitle"
                v-show="editTitle"
                v-model="projectDetail.title"
                type="text"
                placeholder="Project title..."
                class="form-control mb-3 title-field exclude-outside-click h1"
                @change="updateProjectTitle"
                @blur="editTitle=false;"></textarea>
              </label>
              <div class="project-number"><span>Project Number: {{ projectDetail.project_number }}</span></div>
              <div class="project-due-date">
                Project Due Date:
                <!-- <span class="exclude-outside-click" v-show="showDueDateDatepicker">
                  <span @click="showDatePicker" class="exclude-outside-click" v-if="projectDetail.due_date">{{ projectDetail.due_date | moment("DD MMMM, YYYY") }}</span>
                  <span @click="showDatePicker" class="exclude-outside-click" v-else>No Date</span>
                </span>
                -->
                <span ref="refDatepickerWrapper" class="editable-project-due-date" @click="projectDueDateClick">
                  <div class="custom-field-outside-bg-mobile" v-show="editProjectDueDateBg"></div>
                  <vuejs-datepicker
                    ref="projectDueDate"
                    v-model="projectDetail.due_date"
                    @input="updateProjectDueDate"
                    @focusin.native="findPosition"
                    @selected="projectDueDateSelected"
                    v-field-dismiss="editProjectDatePickerClickOutside"
                    placeholder="No Date"
                  >
                    <div slot="beforeCalendarHeader" class="calender-header">
                      <b-button class="remove-dl-btn" variant="text" @click="resetDeadline">Remove Deadline</b-button>
                      <b-button class="today-btn" variant="text" @click="onToday">Today</b-button>
                    </div>
                  </vuejs-datepicker>
                </span>
              </div>
              <!-- <div
              class="field-box"
              v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'project_due_date'})"
              :key="'prj__title__'+index"
              >
                <ProjectCustomFields :deliverable="projectDetail" :customField="field" />
              </div> -->
            </div>
          </div>
          <div v-if="projectDeliverables.length" class="project--milestones">
            <label class="field-label">PROJECT MILESTONES</label>
            <div class="project--milestones-wrap">
              <div v-b-tooltip="{ customClass: 'milestone--tooltip', html: true, title: tipData(projectDeliverables[index-1]), trigger: 'hover' }" :class="{'active': projectDeliverables[index-1].is_complete == 1, 'dots': index <= projectDeliverables.length}" class="milestone" v-for="index in projectDeliverables.length">
                <span class="milestone--full--deliverable">&nbsp;</span>
                <div class="milestone--task--expanson">
                  <span @click="scrollToTask(projectDeliverables[index-1].tasks[index1-1].id, index)" :style="{backgroundColor: tryJSONParse(getFieldJson(projectDeliverables[index-1].tasks[index1-1].taskFields, 'status').value).color}" v-for="index1 in projectDeliverables[index-1].tasks.length"
                  v-b-tooltip="{ customClass: 'milestone--tooltip', html: true, title: tipTaskData(projectDeliverables[index-1].tasks[index1-1]), trigger: 'hover', placement: 'bottom' }">&nbsp;</span>
                </div>
              </div>
            </div>
            <div class="dates">
              <span class="left">{{ projectDetail.start_date | moment("MMMM DD, YYYY") }}</span>
              <span class="right">{{ projectDetail.due_date | moment("MMMM DD, YYYY")  }}</span>
            </div>
          </div>
          <div
          class="field-box project--detail--field"
          v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'project_detail'})"
          :key="'prj__detail__'+index"
          >
            <ProjectCustomFields :deliverable="projectDetail" :customField="field" />
          </div>
          <div class="project--resources">
            <div class="dropdown project--resources--title">
              <button
                title="Add resource"
                class="add-resource-button exclude-outside-click d-inline-block"
                id="add-resource-button"
                data-toggle="dropdown" aria-expanded="false"
              >Resources</button>
              <plus-button data-toggle="dropdown" aria-expanded="false" data-reference="parent"></plus-button>
              <div class="dropdown-menu project--resources--type--menu">
                <a class="dropdown-item" href="#" v-for="(type,i) in optionsForLinkType" :key="i" @click="addResourceMenuItemClick(type.id, $event)"><img class="link-type-icon" :src="require(`@/csmworkflow/img/${type.icon}`)"> {{type.name}}</a>
              </div>
            </div>
            <div class="project--resources--content">
              <div class="resource-entry"
                :class="userCanEditProject ? 'editable' : 'not-editable'"
                v-for="(resource, index) in _.filter(projectDetail.customFields, {field_key: 'link_url'})"
                :key="'link_url-'+index"
                v-if="showResourceBox(resource.value,resource.pfv_id)"
              >
                <!-- <div class="resource-box__url" @click="setCookieForDownload()"></div> -->
                <div class="resource-box__url"></div>
                <a :href="resource.value" @click="openCopyLinkModal(resource.value, $event, index)" target="blank" :id="`project-resource-${index}`">{{customChildFieldValue('link_label',resource.pfv_id) || resource.value}}</a>
                <b-tooltip :target="`project-resource-${index}`" noninteractive triggers="manual"><i class="fas fa-check" style="color:#4C9850;"></i> Link Copied!</b-tooltip>
                <a
                v-b-tooltip.hover
                title="Edit resource"
                class="edit-resource-btn"
                href="#"
                v-if="userCanEditProject"
                @click.prevent="editResource(resource)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <img class="link-type-icon" :src="require(`@/csmworkflow/img/${getLinkTypeObject(customChildFieldValue('link_type',resource.pfv_id)).icon}`)" draggable="false">
                <div class="resource-box__notes" v-if="customChildFieldValue('link_notes',resource.pfv_id)">{{customChildFieldValue('link_notes',resource.pfv_id)}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 right--side">
          <div class="project-right-side-fields">
            <div
              class="field-box"
              v-if="typeof projectDetail == 'object' && projectDetail.engagement_manager"
              >
                <ProjectCustomFields :key="'prjfields'+projectDetail.id" :deliverable="projectDetail" :customField="{field_key: 'engagement_manager',field_name: 'engagement_manager', label: 'Engagement Manager'}" />
            </div>
            <div
              class="field-box"
              v-if="typeof projectDetail == 'object' && projectDetail.project_lead"
              >
                <ProjectCustomFields :key="'prjfields'+projectDetail.id" :deliverable="projectDetail" :customField="{field_key: 'project_lead',field_name: 'project_lead', label: 'Project Lead'}" />
            </div>
            <!-- <div
              class="field-box"
              v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'project_coordinator'})"
              :key="'prj__coordinator__'+index"
              >
              <ProjectCustomFields :deliverable="projectDetail" :customField="field" />
            </div> -->
            <div
            class="field-box"
            v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'project_status'})"
            :key="'prj__budget__'+Math.random()"
            >
              <ProjectCustomFields :key="'prjfields'+projectDetail.id" :deliverable="projectDetail" :customField="field" />
            </div>
            <div
            class="field-box"
            v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'project_audience'})"
            :key="'prj__budget__'+Math.random()"
            >
              <ProjectCustomFields :key="'prjfields'+projectDetail.id" :deliverable="projectDetail" :customField="field" />
            </div>
            <div
            class="field-box"
            v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'budget'})"
            :key="'prj__budget__'+Math.random()"
            >
              <ProjectCustomFields :key="'prjfields'+projectDetail.id" :deliverable="projectDetail" :customField="field" />
            </div>
            <!-- <div
            class="field-box"
            v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'media_budget'})"
            :key="'prj__media__budget__'+index"
            >
              <ProjectCustomFields :deliverable="projectDetail" :customField="field" />
            </div> -->
            <div
              class="field-box"
              v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'requisition_number'})"
              :key="'prj__requisition__number__'+index"
              >
              <ProjectCustomFields :key="'prjfields'+projectDetail.id" :deliverable="projectDetail" :customField="field" />
            </div>
            <!-- <div
              class="field-box"
              v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'priority'})"
              :key="'prj__priority__'+index"
              >
              <ProjectCustomFields :deliverable="projectDetail" :customField="field" />
            </div> -->
            <!-- <div
              class="field-box"
              v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'color_picker'})"
              :key="'prj__color__picker__'+index"
              >
              <ProjectCustomFields :key="'prjfields'+projectDetail.id" :deliverable="projectDetail" :customField="field" />
            </div> -->
            <!-- <div class="field-box">
              <div class="field-box__header"><button
                title="Add resource"
                class="add-resource-button exclude-outside-click d-inline-block"
                @click="addResource"
                >Resources</button>
                <plus-button @click="addResource"></plus-button>
              </div>
              <div class="field-box__content">
                  <!-- <div style="padding-top: 1em; border-bottom: 1px solid #eee;" v-if="userCanEditProject">
                    <VueFilePond
                      name="file"
                      ref="resourcePond"
                      label-idle="Drop files here or Click to select files"
                      :allow-multiple="true"
                      :dropOnElement="true"
                      :dropOnPage="false"
                      :allowRevert="false"
                      v-bind:files="filepond"
                      v-on:init="handleFilePondInit"
                    />
                  </div> -->
                  <!-- <div class="resource-box"
                  v-for="(resource, index) in _.filter(projectDetail.customFields, {field_key: 'link_url'})"
                  :key="'link_url-'+index"
                  v-if="showResourceBox(resource.value,resource.pfv_id)"
                  >
                    <div class="resource-box__url" v-html="getResourceValue(resource.value,resource.pfv_id)" @click="setCookieForDownload()"></div>
                    <a
                    v-b-tooltip.hover
                    title="Edit resource"
                    class="edit-resource-btn"
                    href="#"
                    v-if="userCanEditProject"
                    @click.prevent="editResource(resource)"
                    >
                      <i class="fas fa-edit"></i>
                    </a>
                    <div class="resource-box__notes" v-if="customChildFieldValue('link_notes',resource.pfv_id)">{{customChildFieldValue('link_notes',resource.pfv_id)}}</div>
                  </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div :class="{'open': showModalOptions, 'calendar-controls': $router.currentRoute.name == 'calendar'}" class="responsive-edit-modal-controls">
      <button
      v-b-tooltip.hover
      title="Delete Project"
      @click="removeProject()"
      class="btn delete-deliverable-btn"
      v-if="userCanEditProject"
      >
        <i class="fas fa-trash-alt"></i>
      </button>
      <button
      v-if="$router.currentRoute.name == 'calendar'"
      v-b-tooltip.hover
      title="Close"
      @click="onCloseModal"
      class="btn close-deliverable-btn"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <b-modal v-model="showRemoveProject" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveProject" ok-title="Yes, Delete">
      <p>Are you sure you want to delete this project?</p>
    </b-modal>
    <b-modal centered  hide-footer id="createProjectLinkModal" title="New Resource / Link" @shown="focusLinkModal">
      <CreateProjectLinkModal  ref="refLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel" v-bind:link-notes="linkNotes" v-bind:link-type="linkType" />
    </b-modal>
    <b-modal hide-footer id="editProjectLinkModal" title="Update Resource / Link" @shown="focusEditLinkModal">
      <EditProjectLinkModal  ref="refEditLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel" v-bind:link-notes="linkNotes" v-bind:link-type="linkType" v-bind:is-file="editLinkIsFile" />
    </b-modal>
    <b-modal centered id="linkCopyLinkModal" title="Copy Link" ok-only ok-title="Done">
      <LinkCopyLinkModal :linkUrl="linkCopyModalValue" />
  </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import Datepicker from "vuejs-datepicker";
import ProjectCustomFields from "../common/ProjectCustomField";
import { mapActions, mapGetters, mapMutations } from "vuex";
import ProjectDepartments from "./ProjectDepartments";
import Format from "../../utility/Format";
import Autocomplete from '@trevoreyre/autocomplete-vue';
import CreateProjectLinkModal from "./CreateProjectLinkModal";
import EditProjectLinkModal from "./EditProjectLinkModal";
import toast from "../../toast";
import vueFilePond from "vue-filepond";
import LinkCopyLinkModal from "../common/LinkCopyLinkModal.vue";

const VueFilePond = vueFilePond();

import "filepond/dist/filepond.min.css";

export default {
  props: ['projectDeliverables'],
  data() {
    return {
      Format,
      dateSelected: false,
      showModalOptions: false,
      renderCount: 1,
      editTitle: false,
      showRemoveProject: false,
      showRemoveResource:false,
      addResourceFlag:false,
      linkUrl:null,
      linkLabel:null,
      linkNotes:null,
      linkType:null,
      completedCount: [],
      currentDotPosition: [],
      filepond: [],
      editLinkIsFile: false,
      editProjectDueDateBg: false,
      linkCopyModalValue: "",
      linkCopyLinkTimeouts: {},
    };
  },
  components: {
    'vuejs-datepicker': Datepicker,
    ProjectCustomFields,
    ProjectDepartments,
    Autocomplete,
    EditProjectLinkModal,
    CreateProjectLinkModal,
    VueFilePond,
    LinkCopyLinkModal,
  },
  computed: {
    ...mapGetters([
      "allDepartments",
      "userAbilities",
      "projectDetail",
      "allCustomFields"
    ]),
    // so that we can use lodash in the template
    _() {
      return _;
    },
    apiUrl() {
      return process.env.MIX_API_BASE_URL;
    },
    userCanEditProject() {
			const userId = localStorage.getItem("userId");
      const project = this.projectDetail;

			if (this.userAbilities.accessAllProjects) {
				return this.userAbilities.editProject;
			}

			let isManager = false;
			if (project.engagement_manager instanceof Object) {
				isManager = userId == project.engagement_manager.id;
			} else {
				isManager = userId == project.engagement_manager;
			}

			return (this.userAbilities.editProject && isManager);
		},
    calculateEndDate() {
      console.log(this.projectDeliverables);
      let latestDueDate = null;

      if (this.projectDeliverables && this.projectDeliverables.length > 0) {
        this.projectDeliverables.forEach(deliverable => {
          if (deliverable.tasks && deliverable.tasks.length > 0) {
            deliverable.tasks.forEach(task => {
              const dueDateField = task.taskFields.filter(x => x.field_key == 'due_date')[0];
              let dueDateFieldValue = null;
              if (dueDateField && dueDateField.value) {
                dueDateFieldValue = Vue.moment(dueDateField.value);
              }
              if (dueDateFieldValue && (!latestDueDate || latestDueDate.isBefore(dueDateFieldValue))) {
                latestDueDate = Vue.moment(dueDateFieldValue);
              }
            });
          }
        });
      }

      return latestDueDate;
    },
    optionsForLinkType() {
      let linkTypeField = this.allCustomFields.find(x => x.id == 37);
      if (!linkTypeField) {
        this.$store.dispatch("fetchAllCustomFields");
      } else {
        console.log(linkTypeField);
        return JSON.parse(linkTypeField.value_set);
      }
		},
  },
  methods: {
    ...mapActions([
      "updateFieldValue",
      "updateProjectFieldValue",
      "fetchProjectDeliverable",
      "highlightTask",
      "updateDueDate"
    ]),
    ...mapMutations([
      "setProjectDetail"
    ]),

    projectDueDateClick() {
        if (this.dateSelected){
            this.editProjectDueDateBg = false;
        }else{
            this.editProjectDueDateBg = true;
        }
        this.dateSelected = false;
    },
    projectDueDateSelected(){
        this.editProjectDueDateBg = false;
        this.dateSelected = true;
    },
    findPosition() {
        console.log("findPosition",this.editProjectDueDateBg)
      if (this.$refs.refDatepickerWrapper.getBoundingClientRect().y > 315) {
        $(".editable-project-due-date .vdp-datepicker__calendar").css("top", "-282px");
      } else {
        $(".editable-project-due-date .vdp-datepicker__calendar").css("top", "unset");
      }
    },
    updateProjectDueDate() {
        console.log("updateProjectDueDate")
      this.updateDueDate({projectData: this.projectDetail}).then(() => {
      })
    //   this.editProjectDueDateBg = false;
    },
    onToday() {
      this.projectDetail.due_date = this.$moment().format("YYYY-MM-DD H:m:s");
      this.$refs.projectDueDate.close();
      this.updateProjectDueDate();
    },
    resetDeadline() {
      this.projectDetail.due_date = null
      this.updateProjectDueDate();
    },
    customDateFormat(date) {
      return this.$moment(date, "YYYY-MM-DD").format("DD MMM, YYYY");
    },
    scrollToDeliverable(deliverableId, dIndex) {
      const id = 'project__deliverable__' + deliverableId;
      const yOffset = -95;
      const element = document.getElementById(id);
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});
    },
    scrollToTask(taskId, dIndex) {
      const id = "task__title__" + taskId;
      const taskElOffset = $(".task-fields .field-block ." + id).offset();
      this.highlightTask(taskId);
      if (taskElOffset.top == 0) {
        this.$root.$emit('bv::toggle::collapse', "task-listing-collapse-" + (dIndex - 1));
      } else {
        this.$nextTick(() => {
          const taskElOffset2 = $(".task-fields .field-block ." + id).offset();
          window.scrollTo({top: taskElOffset2.top - 195, behavior: 'smooth'});
        });
      }
    },
    getFieldJson(fieldArray, fieldKey) {
      let field
      field = _.filter(fieldArray, {field_key: fieldKey})
      if(field) {
        return field[0]
      }
    },
    tipTaskData(taskData) {
      let taskTitle = taskData.title
      let taskStatusJson = this.getFieldJson(taskData.taskFields, 'status')
      let taskStatus = this.tryJSONParse(taskStatusJson.value)
      return taskStatus.name + ' : ' + taskTitle
    },
    tipData(deliverableData) {
      return deliverableData.due_date ? Vue.moment(deliverableData.due_date).format("MMMM DD, YYYY") : Vue.moment(deliverableData.created_at).format("MMMM DD, YYYY") + '<br>'+deliverableData.title
    },
    updateProjectTitle() {
      this.projectDetail.title = Format.replaceLineBreaks(this.projectDetail.title, " ");
      this.updateProjectFieldValue(this.projectDetail).then(() => {
        this.fetchProjectDeliverable(1);
      });
    },
    getParentId(obj) {
      if (obj) {
        if (obj.parent_id) {
          return obj.parent_id;
        }
      }
      return null;
    },
    outside() {
      this.editTitle = false;
    },
    showAddResource() {
      this.addResourceFlag = true;
      this.$nextTick(() => {
      });
    },
    clearFlags() {
      this.addSpokespersonFlag = false;
      this.addWhoFlag = false;
    },
    getResourceValue(url, parent_id) {
      let label = this.customChildFieldValue('link_label',parent_id);
      let notes = this.customChildFieldValue('link_notes',parent_id);
      let fileId = this.customChildFieldValue('file_id',parent_id);
      if (url == null && fileId != null && label) {
        return `<a href="${this.apiUrl}downloadFileProject/${this.projectDetail.id}/${fileId}" target="blank">${label}</a>`
      }
      if (url != "" && label != "" && label) {
        return "<a href=\""+url+"\" target=\"blank\">"+label+"</a>";
      }
      if (url != "" && url) {
        return "<a href=\""+url+"\" target=\"blank\">"+url+"</a>";
      }
      if (label != "" && label) {
        return label;
      }
      return "";
    },
    openCopyLinkModal(link, e, i) {
      if (!link.includes("\\")) {
        return;
      }
      e.preventDefault();
      // this.linkCopyModalValue = link;
      // this.$bvModal.show("linkCopyLinkModal");
      this.copyLink(link, i);
    },
    async copyLink(link, resourceId) {
      clearTimeout(this.linkCopyLinkTimeouts[resourceId]);
      Object.keys(this._.filter(this.projectDetail.customFields, {field_key: 'link_url'})).forEach(x => {
        if (x == resourceId) return;
        this.$root.$emit('bv::hide::tooltip', 'project-resource-' + x);
      })

      const navPer = await navigator.permissions.query({name: "clipboard-write"});
      if (navPer.state == "granted" || navPer.state == "prompt") {
          try {
              await navigator.clipboard.writeText(link);
          } catch {
              console.error("clipboard API error. Cannot copy to clipboard.");
              this.legacyCopyMethod(link);
          }
      } else {
        this.legacyCopyMethod(link);
      }

      this.$root.$emit('bv::show::tooltip', 'project-resource-' + resourceId);
      this.linkCopyLinkTimeouts[resourceId] = setTimeout(() => {
        this.$root.$emit('bv::hide::tooltip', 'project-resource-' + resourceId);
      }, 2000);
    },
    legacyCopyMethod(link) {
      let tempInput = document.createElement("input");
      tempInput.style = "position: absolute; left: -1000px; top: -1000px; z-index: -9999";
      tempInput.value = link;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
    },

    showResourceBox(url, parent_id) {
      let fileId = this.customChildFieldValue('file_id',parent_id);
      return (url != null || fileId != null);
    },
    customChildField(key, parent_id) {
        if (this.projectDetail.customFields) {
          let obj = _.filter(this.projectDetail.customFields, {field_key: key, parent_id:parent_id});
          if (obj.length > 0) {
            // lets add it to the
            return obj;
          } else {
            if (key == 'file_id') return null;
            if (key == 'link_type') return [];
            // return the global version of the custom field...
            // let obj = _.filter(this.allCustomFields, {field_key: key});
            let field = _.filter(this.allCustomFields, {field_key: key});
            obj = {};
            obj.id = null;
            obj.parent_id = this.projectDetail.customFields[index].id;
            obj.project_id = this.projectDetail.customFields[index].project_id;
            obj.editing = false;
            obj.field_id = field[0].id;
            obj.field_key = field[0].field_key;
            obj.field_parent_id = field[0].parent_id;
            obj.field_type = field[0].field_type;
            obj.note = field[0].note;
            obj.value = null;
            obj.label = field[0].label;
            obj.value_set = field[0].value_set;
            obj.updated_at = this.projectDetail.customFields[index].updated_at;
            return [obj];
          }
      }
      return [];
    },
    customChildFieldValue(key, parent_id) {
      if (this.projectDetail.customFields) {
        let obj = _.filter(this.projectDetail.customFields, {field_key: key, parent_id:parent_id});
        if (obj.length > 0) {
          return obj[0].value;
        } else {
          return null;
        }
      }
      return null;
    },
    editResource(resource) {
      this.linkUrl = resource;
      let label =  this.customChildField('link_label', resource.pfv_id);
      if (label.length > 0) {
        this.linkLabel = label[0];
      } else {
        this.linkLabel = {};
      }
      let notes =  this.customChildField('link_notes', resource.pfv_id);
      if (notes.length > 0) {
        this.linkNotes = notes[0];
      } else {
        this.linkNotes = {};
      }
      let type = this.customChildField('link_type', resource.pfv_id);
      if (type.length > 0) {
        this.linkType = type[0];
      } else {
        this.linkType = {
          id:null,
          field_id:37,
          project_field_id:_.filter(this.projectDetail.customFields, {field_key: 'link_type'})[0]?.projectFieldId,
          parent_field_id:20,
          field_key:"link_type",
          field_type:"select",
          parent_id:null,
          project_id:this.projectDetail.projectId,
          value:1
        };
      }
      let fileId = this.customChildField('file_id', resource.pfv_id);
      this.editLinkIsFile = Boolean(fileId);
      this.$bvModal.show("editProjectLinkModal");
    },
    addResource(typeId = 1) {
      // if(!this.userAbilities.editMediaCall || this.projectDetail.permissions.viewOnly) return;
      if (!this.userCanEditProject) return;
      this.linkUrl = {
        id:null,
        field_id:20,
        project_field_id:_.filter(this.projectDetail.customFields, {field_key: 'link_url'})[0].projectFieldId,
        parent_field_id:null,
        field_key:"link_url",
        field_type:"text",
        parent_id:null,
        project_id:this.projectDetail.projectId,
        value:null
      };
      this.linkLabel = {
        id:null,
        field_id:21,
        project_field_id:_.filter(this.projectDetail.customFields, {field_key: 'link_label'})[0].projectFieldId,
        parent_field_id:20,
        field_key:"link_label",
        field_type:"text",
        parent_id:null,
        project_id:this.projectDetail.projectId,
        value:null
      };
      this.linkNotes = {
        id:null,
        field_id:22,
        project_field_id:_.filter(this.projectDetail.customFields, {field_key: 'link_notes'})[0].projectFieldId,
        parent_field_id:20,
        field_key:"link_notes",
        field_type:"text",
        parent_id:null,
        project_id:this.projectDetail.projectId,
        value:null
      };
      this.linkType = {
        id:null,
        field_id:37,
        project_field_id:_.filter(this.projectDetail.customFields, {field_key: 'link_type'})[0]?.projectFieldId,
        parent_field_id:20,
        field_key:"link_type",
        field_type:"select",
        parent_id:null,
        project_id:this.projectDetail.projectId,
        value:typeId
      }
      this.$bvModal.show("createProjectLinkModal");
    },
    addResourceMenuItemClick(typeId, e) {
      e.preventDefault();
      this.addResource(typeId);
    },
    removeProject() {
      this.showRemoveProject = true;
    },
    onConfirmRemoveProject() {
      if (this.projectDetail.id) {
        let that = this;
        let projectId = this.projectDetail.id;
        this.$store.dispatch("removeProject", { projectId: projectId }).then(function() {
          that.$store.dispatch('manageUndoActivation', 'Project removed.');
          that.$router.push('/project');
        });
      }
    },
    focusLinkModal() {
      this.$refs.refLinkModal.focusMyElement();
    },
    focusEditLinkModal() {
      this.$refs.refEditLinkModal.focusMyElement();
    },
    onCloseModal() {
        this.$bvModal.hide("editProjectModal");
        if(this.$router.currentRoute.name == 'calendar') {
          this.$root.$emit('re__fetch__calendar__data')
        }
    },
    activateTitleField() {
      if (!this.userCanEditProject) return;
      let that = this
      this.editTitle=true;
      setTimeout(function() {
        that.$refs.deliverableTitle.select();
      }, 100)
    },

    handleFilePondInit() {
      this.$refs.resourcePond._pond.setOptions({
        server: {
						headers: {
							Authorization: "Bearer " + this.$store.getters.authToken
						},
						process: {
							method: 'POST',
							url: `${this.apiUrl}uploadFileProject`,
							withCredentials: true,
              ondata: this.handleFilePondSubmit,
              onload: this.handleFilePondSuccess,
          },
        }
      });
    },
    handleFilePondSubmit(data) {
      // data.append('type', 1);
      data.append('id', this.projectDetail.id);
      return data;
    },
    handleFilePondSuccess(r) {
      let projectR = JSON.parse(r);
      this.setProjectDetail(projectR.projectDetail);
      console.log(this.projectDetail);
    },

    setCookieForDownload() {
      this.$store.dispatch("setUserAuthCookie");
    },

    getLinkTypeObject(id) {
      if (id == null) id = 1;
      const r = this.optionsForLinkType.find(x => x.id == id);
      return r;
    },

    editProjectDueDateClick() {
        console.log("editProjectDueDateClick")
      if (!this.editProjectDueDateBg) {
        this.editProjectDueDateBg = true;
      }
    },
    editProjectDatePickerClickOutside() {
       console.log("editProjectDatePickerClickOutside")
      this.editProjectDueDateBg = false;
    },
  },
  created() {
    // this.$store.commit('resetProjectDetail')
    // this.$store.commit('resetProjectDeliverables')
  },
  mounted() {
    $('#editProjectModal .modal-content').removeAttr('tabindex');
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.project--detail--field {
  margin-top: 50px;
}
.editable-project-due-date {
  .vdp-datepicker {
    display: inline-block;
    .day__month_btn,
    .cell,
    .month__year_btn,
    .vdp-datepicker__calendar header {
      color: #212529;
    }
    input {
      background: transparent;
      color: #BABABA;
      font-size: 22px;
      border: unset;
      cursor: pointer;
      &::placeholder {
        color: #BABABA;
        font-size: 22px;
        opacity: 1;
      }
      &:-ms-input-placeholder {
        color: #BABABA;
        font-size: 22px;
      }
      &::-ms-input-placeholder {
        color: #BABABA;
        font-size: 22px;
      }
    }
  }
}
</style>
